import { TypographyPrinciples, TypographyHeadingTable, TypographyBodyTable, TypographyMetricTable, TypographyCodeTable } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  TypographyPrinciples,
  TypographyHeadingTable,
  TypographyBodyTable,
  TypographyMetricTable,
  TypographyCodeTable,
  React
};